export default "__VITE_ASSET__7b1fb26e__"